"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _vectors = _interopRequireDefault(require("../../vectors"));

var _Icon = require("./Icon.styles");

var _excluded = ["name", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Icon = function Icon(_ref) {
  var name = _ref.name,
      size = _ref.size,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  if (size === 'auto' || size === 'original') {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _vectors["default"])(_objectSpread({
      name: name,
      size: size
    }, props)));
  }

  return /*#__PURE__*/_react["default"].createElement(_Icon.StyledIconContainer, {
    size: size
  }, (0, _vectors["default"])({
    name: name,
    size: size
  }));
};

Icon.defaultProps = {
  size: 'original'
};
Icon.propTypes = {
  /** Name of the icon to be presented */
  name: _propTypes.string.isRequired,

  /** Size of the icon.<br/>
   * 'auto' will adapt itself to the size of the parent container.<br/>
   * 'original' will use the predefined vector size.
   */
  size: (0, _propTypes.oneOf)(['original', 'x-small', 'small', 'normal', 'large', 'x-large', 'auto'])
};
Icon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Icon",
  "props": {
    "size": {
      "defaultValue": {
        "value": "'original'",
        "computed": false
      },
      "description": "Size of the icon.<br/>\r\n'auto' will adapt itself to the size of the parent container.<br/>\r\n'original' will use the predefined vector size.",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'original'",
          "computed": false
        }, {
          "value": "'x-small'",
          "computed": false
        }, {
          "value": "'small'",
          "computed": false
        }, {
          "value": "'normal'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }, {
          "value": "'x-large'",
          "computed": false
        }, {
          "value": "'auto'",
          "computed": false
        }]
      },
      "required": false
    },
    "name": {
      "description": "Name of the icon to be presented",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = Icon;
exports["default"] = _default;